import { Difficulty } from '../../types';
import { useTimer } from '../../hooks/useTimer';
import { useGameStore } from '../../store/gameStore';
import { motion } from 'framer-motion';

interface GameStatusProps {
  difficulty: Difficulty;
  levelNumber: number;
  mistakes: number;
  maxMistakes?: number;
}

const difficultyLabels: Record<Difficulty, string> = {
  beginner: '初学者',
  easy: '容易',
  medium: '中等',
  hard: '困难',
};

export default function GameStatus({
  difficulty,
  levelNumber: _levelNumber,
  mistakes,
  maxMistakes = 3,
}: GameStatusProps) {
  void _levelNumber; // Reserved for future use
  const { formattedTime } = useTimer();
  const { isPaused, togglePause, isComplete } = useGameStore();
  const diffLabel = difficultyLabels[difficulty];

  return (
    <div className="flex items-center justify-between text-sm text-gray-700">
      {/* Left: Difficulty */}
      <span className="font-medium">{diffLabel}</span>
      
      {/* Center: Errors */}
      <div className="flex items-center gap-1">
        <span>错误:</span>
        <span className={`font-medium ${mistakes >= maxMistakes ? 'text-red-500' : 'text-green-600'}`}>
          {mistakes}/{maxMistakes}
        </span>
      </div>
      
      {/* Right: Time and Pause */}
      <div className="flex items-center gap-2">
        <span className="font-mono">{formattedTime}</span>
        {!isComplete && (
          <motion.button
            className="text-green-600 hover:text-green-700"
            onClick={togglePause}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            {isPaused ? (
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
              </svg>
            )}
          </motion.button>
        )}
      </div>
    </div>
  );
}

